/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSlideShow as ResolvedStandaloneSlideShow } from 'base/components/standalone/SlideShow';

export const SlideShow: typeof ResolvedStandaloneSlideShow = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSlideShow {...props} />
        </ErrorBoundary>
    );
});

export type SlideShowProps = PropsFromComponent<typeof SlideShow>;

/** @deprecated Use slot architecture instead */
export const SlideShowWith = (extras: DynamicStandaloneExtras): typeof SlideShow => {
    return function SlideShow(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SlideShow');
        return <ResolvedStandaloneSlideShow {...mergeProps({ options: { theme } }, props)} />;
    }
}